<div class="row">
  <div class="col-lg-6 col-md-8 col-sm-10 col-12">
    <div class="form-group">
      <label for="nameInput">Name *</label>
      <input id="nameInput" type="text" class="form-control"
             [(ngModel)]="documentPolicy.name">
      <div class="form-text text-danger">{{ documentPolicyErrors.name }}</div>
    </div>

    <div class="form-group">
      <label for="statusSelect">Status *</label>
      <select id="statusSelect" class="custom-select"
              [(ngModel)]="documentPolicy.status">
        <option value="{{ DocumentPolicyStatus.active }}">Active</option>
        <option value="{{ DocumentPolicyStatus.retired }}">Retired</option>
      </select>
      <div class="form-text text-danger">{{ documentPolicyErrors.status }}</div>
    </div>

    <div class="form-group">
      <label>Policy Text *</label>
      <app-markdown-editor [id]="'policyText'" [(content)]="documentPolicy.content"></app-markdown-editor>
      <div class="form-text text-danger">{{ documentPolicyErrors.content }}</div>
    </div>

  </div>
</div>
